export default __webpack_public_path__ + "abbe98247a977a98ab5382a089f89229.svg";